import { fetchDocumentFicha } from '../common/apiClient';
import { mapDocumentToFicha } from './documentFichaMapper';
import { buildDocumentByIdQuery } from './documentDetailQuery';
import { fetchCanonicalDocumentRecord } from './documentRedirect';

export async function loadDocumentFicha(callApi, documentId, { canEdit = false } = {}) {
  if (!documentId) {
    throw new Error('ID de documento requerido');
  }

  if (process.env.REACT_APP_DOCUMENT_V1_ENABLED === 'true') {
    try {
      const ficha = await fetchDocumentFicha(documentId);
      if (ficha) {
        return {
          ...ficha,
          permissions: { can_edit: canEdit },
        };
      }
    } catch {
      /* fallback GraphQL */
    }
  }

  const record = await fetchCanonicalDocumentRecord(
    callApi,
    buildDocumentByIdQuery,
    documentId,
  );
  if (!record) {
    throw new Error('Documento no encontrado');
  }
  return mapDocumentToFicha(record, { canEdit });
}
